import React from 'react'
import { useState } from 'react';
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";

function SMSCampaignReport() {

    const [showfilter, setshowfilter] = useState(false)
    const [Campaignname, setCampaignname] = useState('')
    const [SenderId, setSenderId] = useState('')
    const [Creditused, setCreditused] = useState('')
    const [IsScheduled, setIsScheduled] = useState('')

    const initialUsers = [];
    const [users, setUsers] = useState(initialUsers);




    const [open, setopen] = useState(false)







    const [currentPage, setcurrentPage] = useState(1);
    const [usersperpage, setuserperpages] = useState(10);

    const indexoflastuser = currentPage * usersperpage;
    const indexoffirstuser = indexoflastuser - usersperpage
    const filteruser = users.slice(indexoffirstuser, indexoflastuser)
    const totalpages = Math.ceil(users.length / usersperpage)
    const [Open, setOpen] = useState(false)
    return (
        <>
            <div onClick={() => setshowfilter(!showfilter)}
                className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                    <RiCollapseDiagonalLine />
                    Filter Records
                </div>
                <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                    {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                </div>
            </div>
            {showfilter &&
                <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
                    <div className='w-[100%] flex flex-wrap gap-2'>

                        <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Campaign name:</label>
                            <input
                                value={Campaignname}
                                onChange={(e) => setCampaignname(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'

                                type="text"
                            />
                        </div>
                        <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
                                SenderId</label>
                            <input
                                value={SenderId}
                                onChange={(e) => setSenderId(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'

                                type="text"
                            />
                        </div>
                        <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Credit used</label>
                            <input
                                value={Creditused}
                                onChange={(e) => setCreditused(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>
                        <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Is Scheduled</label>
                            <select name="" id=""
                                value={IsScheduled}
                                onChange={(e) => setIsScheduled(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            >
                                <option value="">Select Status</option>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                        </div>
                        <div className='w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4'>
                            <button

                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                            </button>

                            <button
                                className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                            </button>
                        </div>

                    </div>
                </div>
            }
            <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] relative ">
                <thead className="">
                    <tr className="text-left text-sm font-semibold text-gray-700">
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Campaign Date</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Campaign Name</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>SenderID</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Spent</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>

                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Spent</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Message</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Campaign Flow</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Scheduled Info</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Is Journey Campaign</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Total Count</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>
                        <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                            <div className="flex justify-between items-center gap-2">
                                <span className='text-[11px] text-[#576071] dark:text-[#fff]'>View</span>
                                <button type="button" className="text-gray-500 hover:text-black">
                                    <TbArrowsSort />
                                </button>
                            </div>
                        </th>

                    </tr>
                </thead>

                <tbody>
                    {filteruser.length > 0 ? (
                        filteruser.map((user) => (
                            <tr
                                key={user.id}
                                className=" text-gray-500 odd:bg-white even:bg-[#edf1f5] 
        dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                            >
                                <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.WABANumber}</td>
                            </tr>
                        ))
                    ) : (
                        <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                            <td colSpan="11" className="p-1 text-[11px]">
                                No data found
                            </td>
                        </tr>

                    )}
                </tbody>
            </table>
            <div className='flex justify-between w-[100%] '>
                <p className='text-[11px] text-[#3f7fc8] mt-2' >Showing {indexoffirstuser} to {indexoflastuser} of {users.length} records</p>
                <div className="flex justify-center mt-4 space-x-3 relative z-0">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setcurrentPage((prev) => prev - 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition "
                    >
                        Prev
                    </button>

                    {/* {Array.from({length: Math.ceil(users.length /usersperpage )}).map((_, index)=>
                  
                  <button key={index}
                  onClick={()=> setcurrentPage(index + 1)}
                  className={`${currentPage === index + 1 ? 'bg-[#448c74] text-[#fff]':'bg-gray-200 '} px-2`}
                  >
                   {index + 1}
                  </button>
               )

               } */}


                    {<p className='text-[11px] text-[#3f7fc8] mt-2' > {currentPage} page of  {totalpages}  pages</p>

                    }

                    <button
                        disabled={currentPage === Math.ceil(users.length / usersperpage)}
                        onClick={() => setcurrentPage((prev) => prev + 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    )
}

export default SMSCampaignReport
